export const clienteShareMock = [[
{
  "isSuccess": true,
  "data": [
    [
      {
        "id": 892,
        "codigoVendedor": "234182",
        "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
        "basesClienteShare": [
          {
            "id": 1,
            "clientesShare": [
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.54,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.828,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.006,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.18,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.24,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.54,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 3.6,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 7.2,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 1.44,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.02,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.36,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO RESINADO / PORCELANATO"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.54,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.3,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.02,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO RESINADO / PORCELANATO"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.324,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 1.44,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.014,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 1.8,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.084,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.018,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 5.6,
                "grupoProduto": "CALES",
                "produto": "LIGA PARA MASSA ITAÚ"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.6,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CAL CEM",
                "consumo": 0.56,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 1.56,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 54,
                "grupoProduto": "CIMENTOS",
                "produto": "OBRAS ESPECIAIS - INDUSTRIAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-07-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 16,
                "grupoProduto": "COLANTES",
                "produto": "OVERCOLL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-07-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 8,
                "grupoProduto": "COLANTES",
                "produto": "AC III"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 6,
                "grupoProduto": "COLANTES",
                "produto": "AC III"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 6,
                "grupoProduto": "COLANTES",
                "produto": "PSP INTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2600,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-07-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 1.4,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.828,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.18,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.54,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.006,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.018,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 1.44,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 1.08,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 3.6,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 1.44,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.014,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.3,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.02,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.02,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO RESINADO / PORCELANATO"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 7.2,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.36,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO RESINADO / PORCELANATO"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.084,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 1.8,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.54,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.54,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CAL CEM",
                "consumo": 0.56,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 1.56,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 54,
                "grupoProduto": "CIMENTOS",
                "produto": "OBRAS ESPECIAIS - INDUSTRIAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 5.6,
                "grupoProduto": "CALES",
                "produto": "LIGA PARA MASSA ITAÚ"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.24,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2406,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.6,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-08-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 12,
                "grupoProduto": "COLANTES",
                "produto": "AC III"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 6,
                "grupoProduto": "COLANTES",
                "produto": "PSP INTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 6,
                "grupoProduto": "COLANTES",
                "produto": "AC III"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-08-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 1.4,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-08-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 16,
                "grupoProduto": "COLANTES",
                "produto": "OVERCOLL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.18,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.828,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 1.08,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.54,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.018,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4.32,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.006,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 1.8,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 1.44,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.084,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.3,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.1,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.2,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO RESINADO / PORCELANATO"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-09-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO ACRÍLICO"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.36,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO RESINADO / PORCELANATO"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.24,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.014,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 1.8,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.54,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.54,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 3.6,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CAL CEM",
                "consumo": 0.56,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 5.6,
                "grupoProduto": "CALES",
                "produto": "LIGA PARA MASSA ITAÚ"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 1.56,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.6,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 54,
                "grupoProduto": "CIMENTOS",
                "produto": "OBRAS ESPECIAIS - INDUSTRIAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 6,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2000,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-09-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 12,
                "grupoProduto": "COLANTES",
                "produto": "AC III"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 6,
                "grupoProduto": "COLANTES",
                "produto": "AC III"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 6,
                "grupoProduto": "COLANTES",
                "produto": "PSP INTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 11.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-09-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 32,
                "grupoProduto": "COLANTES",
                "produto": "OVERCOLL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-09-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.54,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.18,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.006,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.828,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.018,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 7.2,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 3.6,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.24,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.54,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.02,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.36,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO RESINADO / PORCELANATO"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.54,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.3,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.02,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO RESINADO / PORCELANATO"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.324,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 1.44,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.014,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 1.8,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.084,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 1.44,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CAL CEM",
                "consumo": 0.56,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 5.6,
                "grupoProduto": "CALES",
                "produto": "LIGA PARA MASSA ITAÚ"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 1.56,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.6,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 54,
                "grupoProduto": "CIMENTOS",
                "produto": "OBRAS ESPECIAIS - INDUSTRIAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2220,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-06-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 16,
                "grupoProduto": "COLANTES",
                "produto": "OVERCOLL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 6,
                "grupoProduto": "COLANTES",
                "produto": "PSP INTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-06-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 8,
                "grupoProduto": "COLANTES",
                "produto": "AC III"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-06-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 1.4,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 6,
                "grupoProduto": "COLANTES",
                "produto": "AC III"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 8231,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 12397,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 12397,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 12397,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 6,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 12397,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 6,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 13641,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL (1000)"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 13641,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL (1000)"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 13641,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL (1000)"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 13641,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL (1000)"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14353,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14353,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14353,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14353,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14603,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14603,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.12,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14603,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.12,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14603,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14603,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.12,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14603,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14603,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.12,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14603,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14605,
                "anoMes": "2026-06-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "OVERCOLL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14605,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.02,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14605,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14605,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14605,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.02,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14605,
                "anoMes": "2026-07-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "OVERCOLL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14608,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL (1000)"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14608,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.02,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14608,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14608,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14608,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 6,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14608,
                "anoMes": "2026-08-01T00:00:00",
                "player": "ARGASSUL",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14608,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14608,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL (1000)"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14608,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.02,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14608,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14608,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 8,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14608,
                "anoMes": "2026-09-01T00:00:00",
                "player": "ARGASSUL",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14608,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14608,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14608,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.36,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL (1000)"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14608,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14608,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14608,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14608,
                "anoMes": "2026-07-01T00:00:00",
                "player": "ARGASSUL",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14608,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14608,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14608,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14608,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.36,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL (1000)"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14608,
                "anoMes": "2026-06-01T00:00:00",
                "player": "ARGASSUL",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14608,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14618,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14618,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14618,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14618,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14629,
                "anoMes": "2026-09-01T00:00:00",
                "player": "SHALOM",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14629,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.1,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14629,
                "anoMes": "2026-09-01T00:00:00",
                "player": "SHALOM",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14629,
                "anoMes": "2026-09-01T00:00:00",
                "player": "KERACOLL",
                "consumo": 6,
                "grupoProduto": "COLANTES",
                "produto": "OUTROS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14629,
                "anoMes": "2026-09-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 45,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14629,
                "anoMes": "2026-08-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 42,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14629,
                "anoMes": "2026-08-01T00:00:00",
                "player": "SHALOM",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14629,
                "anoMes": "2026-08-01T00:00:00",
                "player": "SHALOM",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14629,
                "anoMes": "2026-06-01T00:00:00",
                "player": "SHALOM",
                "consumo": 1.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14629,
                "anoMes": "2026-06-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 42,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14629,
                "anoMes": "2026-06-01T00:00:00",
                "player": "SHALOM",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14629,
                "anoMes": "2026-07-01T00:00:00",
                "player": "SHALOM",
                "consumo": 1.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14629,
                "anoMes": "2026-07-01T00:00:00",
                "player": "SHALOM",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14629,
                "anoMes": "2026-07-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 42,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14643,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "COLANTES",
                "produto": "PSP INTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14643,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 6,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14643,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14643,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14643,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 6,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14643,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "COLANTES",
                "produto": "PSP INTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14643,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 16,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14643,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "COLANTES",
                "produto": "PSP INTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14643,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14643,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14643,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 12,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14643,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.6,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14643,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14643,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "COLANTES",
                "produto": "PSP INTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14648,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 22,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14648,
                "anoMes": "2026-09-01T00:00:00",
                "player": "LIZ",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14648,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 8,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14648,
                "anoMes": "2026-08-01T00:00:00",
                "player": "LIZ",
                "consumo": 32,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14648,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14648,
                "anoMes": "2026-06-01T00:00:00",
                "player": "LIZ",
                "consumo": 38,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14648,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14648,
                "anoMes": "2026-07-01T00:00:00",
                "player": "LIZ",
                "consumo": 38,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14649,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14649,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14649,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC III"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14649,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC III"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14649,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14649,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14649,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.1,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14649,
                "anoMes": "2026-06-01T00:00:00",
                "player": "SIKA",
                "consumo": 0.03,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14649,
                "anoMes": "2026-06-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 32,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14649,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 14,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14649,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14649,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14649,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.1,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14649,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14649,
                "anoMes": "2026-07-01T00:00:00",
                "player": "SIKA",
                "consumo": 0.03,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14649,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC III"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14649,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 14,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14649,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14649,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14649,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14649,
                "anoMes": "2026-07-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 32,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14649,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC III"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14649,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.018,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14649,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.36,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL (1000)"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14649,
                "anoMes": "2026-09-01T00:00:00",
                "player": "SIKA",
                "consumo": 0.03,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14649,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.1,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14649,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC III"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14649,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14649,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14649,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14649,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 12,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14649,
                "anoMes": "2026-09-01T00:00:00",
                "player": "INKOR",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14649,
                "anoMes": "2026-09-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 50,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14649,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14649,
                "anoMes": "2026-09-01T00:00:00",
                "player": "INKOR",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "OUTROS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14649,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC III"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14649,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14649,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14649,
                "anoMes": "2026-08-01T00:00:00",
                "player": "SIKA",
                "consumo": 0.03,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14649,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.1,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14649,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14649,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14649,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC III"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14649,
                "anoMes": "2026-08-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 50,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14649,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 12,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14649,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14649,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14649,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC III"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14653,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14653,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14653,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14653,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14757,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14757,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14757,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14757,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14757,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14757,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14757,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14757,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14757,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14757,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14757,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.8,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14757,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14765,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14794,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14794,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14794,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14794,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14794,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14794,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14794,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14794,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14806,
                "anoMes": "2026-08-01T00:00:00",
                "player": "ARGASSUL",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14806,
                "anoMes": "2026-09-01T00:00:00",
                "player": "ARGASSUL",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14806,
                "anoMes": "2026-06-01T00:00:00",
                "player": "ARGASSUL",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14806,
                "anoMes": "2026-07-01T00:00:00",
                "player": "ARGASSUL",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14809,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14809,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14809,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14809,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14809,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14809,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14809,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14809,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14809,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14809,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14809,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14809,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14821,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14821,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.6,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14821,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14821,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14821,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14821,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14821,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.6,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14821,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14821,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14821,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14821,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.5,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14821,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14827,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14827,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14827,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14827,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14890,
                "anoMes": "2026-06-01T00:00:00",
                "player": "SHALOM",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14890,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14890,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14890,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14890,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14890,
                "anoMes": "2026-07-01T00:00:00",
                "player": "SHALOM",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14890,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14890,
                "anoMes": "2026-09-01T00:00:00",
                "player": "SHALOM",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14890,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.03,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14890,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14890,
                "anoMes": "2026-08-01T00:00:00",
                "player": "SHALOM",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14890,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14940,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14940,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2.5,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14940,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14940,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2.5,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14940,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14940,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14940,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14940,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2.5,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14940,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14940,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14940,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2.5,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14940,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14947,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14947,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14947,
                "anoMes": "2026-08-01T00:00:00",
                "player": "KERACOLL",
                "consumo": 0.03,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14947,
                "anoMes": "2026-09-01T00:00:00",
                "player": "KERACOLL",
                "consumo": 0.03,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 14974,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 14974,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 14974,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 14974,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14991,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.009,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14991,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.0072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14991,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.0072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14991,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0045,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14991,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0045,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14991,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.0108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14991,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.009,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 14991,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.0072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15000,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15000,
                "anoMes": "2026-06-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 16,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15000,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15000,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.09,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15000,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15000,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15000,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15000,
                "anoMes": "2026-09-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 19,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15000,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.4,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15000,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15000,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.09,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15000,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15000,
                "anoMes": "2026-08-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 14,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15000,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15000,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15000,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15000,
                "anoMes": "2026-07-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 15,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15000,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15000,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.09,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15000,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15004,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15004,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15004,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15004,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15024,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15024,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.8,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15024,
                "anoMes": "2026-09-01T00:00:00",
                "player": "SHALOM",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15024,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15024,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.8,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15024,
                "anoMes": "2026-08-01T00:00:00",
                "player": "SHALOM",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15024,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15024,
                "anoMes": "2026-06-01T00:00:00",
                "player": "SHALOM",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15024,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15024,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.8,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15024,
                "anoMes": "2026-07-01T00:00:00",
                "player": "SHALOM",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15037,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 3.6,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15037,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15037,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.1,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15037,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 4.8,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15037,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.1,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15037,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 4.8,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15037,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15037,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 3.6,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15056,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15056,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 42,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15056,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15056,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15056,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15056,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 60,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15056,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15056,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15056,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15056,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15056,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15056,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 42,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15056,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15056,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15056,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15056,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 42,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15056,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15056,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15056,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15056,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15073,
                "anoMes": "2026-09-01T00:00:00",
                "player": "ARGASSUL",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15073,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15076,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.4,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15076,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15076,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.5,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15076,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15076,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.5,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15076,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15076,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15076,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.5,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15086,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15086,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15086,
                "anoMes": "2026-07-01T00:00:00",
                "player": "SHALOM",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15086,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.03,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15086,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15086,
                "anoMes": "2026-06-01T00:00:00",
                "player": "SHALOM",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15094,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15094,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.4,
                "grupoProduto": "COLANTES",
                "produto": "AC III"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15094,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.4,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15094,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15094,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC III"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15094,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.4,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15094,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15094,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "AC III"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15094,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15094,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.07,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15094,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.4,
                "grupoProduto": "COLANTES",
                "produto": "AC III"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15094,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15101,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15101,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15101,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15101,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15101,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15101,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15101,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15101,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15101,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15101,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15101,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15101,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15101,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 3.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15101,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15101,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15101,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15108,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15108,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15108,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15108,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 4.4,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15110,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.12,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15110,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 5.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15110,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15110,
                "anoMes": "2026-06-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 190,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15110,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15110,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15110,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.09,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15110,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15110,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 5.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15110,
                "anoMes": "2026-07-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 164,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15110,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15110,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15110,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.09,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15110,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15110,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 4.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15110,
                "anoMes": "2026-08-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 150,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15110,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15110,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.09,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15110,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15110,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15110,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15110,
                "anoMes": "2026-09-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 150,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15115,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15115,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15115,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15115,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15115,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15115,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15115,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15115,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15123,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 3,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15123,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 3,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15123,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15123,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15125,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15125,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15125,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15125,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15125,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15125,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15125,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15125,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15125,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15125,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15125,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15125,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15127,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL (1000)"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15127,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15127,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15127,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 8,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15127,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.008,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15127,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15127,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15127,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL (1000)"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15127,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 32,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15127,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15127,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.008,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15127,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15127,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15127,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL (1000)"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15127,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.016,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15127,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 12,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15127,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15127,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15127,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15127,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15127,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL (1000)"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15127,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 12,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15127,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.016,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15127,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15131,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 3.5,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15131,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15131,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15131,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 3,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15139,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15139,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15139,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15139,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 28,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15139,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15139,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 30,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15139,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15139,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15139,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 28,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15139,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15139,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15139,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15139,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "OUTROS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15139,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15139,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15139,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15139,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15139,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.25,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15139,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 30,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15142,
                "anoMes": "2026-07-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 28,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15142,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15142,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15142,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.0072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15142,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15142,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15142,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.0072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15142,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15142,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15142,
                "anoMes": "2026-08-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 28,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15142,
                "anoMes": "2026-09-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 28,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15142,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15142,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15142,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15142,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.0072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15142,
                "anoMes": "2026-06-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 28,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15142,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15142,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15142,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15142,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.0144,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15152,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15152,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15152,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15152,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15156,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15156,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15156,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15156,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15156,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15156,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15156,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15156,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15156,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15156,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15156,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15156,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15156,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15156,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15156,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15156,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15170,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15170,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15170,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15170,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15170,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.0072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15170,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15170,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15170,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.0108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15170,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15170,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15170,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.018,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15170,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15170,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.018,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15170,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.0108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15170,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15170,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15170,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.018,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15170,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15170,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15170,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.018,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15170,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.0108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15170,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.1,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.018,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-07-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 0.1,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-07-01T00:00:00",
                "player": "SIKA",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO PLASTIFICANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.0072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO PLASTIFICANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-07-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 145,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.003,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO PLASTIFICANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.003,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO PLASTIFICANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-08-01T00:00:00",
                "player": "SIKA",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.018,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.0072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO PLASTIFICANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-08-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 160,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO PLASTIFICANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-08-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.1,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO PLASTIFICANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.018,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-09-01T00:00:00",
                "player": "SIKA",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.1,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-09-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-09-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 160,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.0072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO PLASTIFICANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.003,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO PLASTIFICANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO PLASTIFICANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.18,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-06-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 0.14,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-06-01T00:00:00",
                "player": "SIKA",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 3.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-06-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 132,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.003,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO PLASTIFICANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.0072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO PLASTIFICANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 4.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15194,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15199,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.008,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15199,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15199,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.018,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15199,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15199,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.02,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15199,
                "anoMes": "2026-06-01T00:00:00",
                "player": "ARGASSUL",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15199,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.8,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15199,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15199,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.018,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15199,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.018,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15199,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.008,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15199,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.02,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15199,
                "anoMes": "2026-08-01T00:00:00",
                "player": "KERACOLL",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15199,
                "anoMes": "2026-08-01T00:00:00",
                "player": "ARGASSUL",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15199,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.8,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15199,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15199,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.6,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15199,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.008,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15199,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.018,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15199,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.018,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15199,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15199,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.02,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15199,
                "anoMes": "2026-09-01T00:00:00",
                "player": "ARGASSUL",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15199,
                "anoMes": "2026-09-01T00:00:00",
                "player": "KERACOLL",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15199,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.6,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15199,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.8,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15199,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.018,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15199,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.008,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15199,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.02,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15199,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.018,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15199,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.8,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15199,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15199,
                "anoMes": "2026-07-01T00:00:00",
                "player": "ARGASSUL",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15211,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15211,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15211,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "PSP INTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15211,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15211,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 16,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15211,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15211,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15211,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "PSP INTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15211,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15211,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 20,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15211,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15211,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "PSP INTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15211,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15211,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15211,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 26,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15211,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15211,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15211,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "PSP INTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15211,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15211,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 26,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15213,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15213,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15213,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15213,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15213,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15213,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15213,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15213,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15213,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15213,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15213,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15213,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15227,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0432,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO PLASTIFICANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15227,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 7.2,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15227,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "PORCELANATO INTERNO CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15227,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.36,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO PLASTIFICANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15227,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.2,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15227,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.016,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO PLASTIFICANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15227,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15227,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 14,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15227,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.015,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO PLASTIFICANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15227,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 14,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15227,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15227,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "PORCELANATO INTERNO CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15227,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.288,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO PLASTIFICANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15227,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 6,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15227,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO PLASTIFICANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15227,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.16,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15227,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.015,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO PLASTIFICANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15227,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.288,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO PLASTIFICANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15227,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO PLASTIFICANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15227,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.16,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15227,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 6,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15227,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "PORCELANATO INTERNO CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15227,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 14,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15227,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15227,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0432,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO PLASTIFICANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15227,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.01,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO PLASTIFICANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15227,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.288,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO PLASTIFICANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15227,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "PORCELANATO INTERNO CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15227,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.18,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15227,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 6,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15227,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 7.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15227,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 28,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.144,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO PLASTIFICANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 5,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.1,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.09,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.006,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.09,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 14,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.006,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO PLASTIFICANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.1,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 14,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO PLASTIFICANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.1,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.006,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.09,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.144,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO PLASTIFICANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.09,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.006,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15229,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15253,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15253,
                "anoMes": "2026-06-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 0.09,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15253,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15253,
                "anoMes": "2026-06-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "OVERCOLL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15253,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15253,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15253,
                "anoMes": "2026-07-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 0.09,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15253,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15253,
                "anoMes": "2026-07-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "OVERCOLL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15253,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15253,
                "anoMes": "2026-08-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15253,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15253,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15253,
                "anoMes": "2026-08-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "OVERCOLL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15253,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15253,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15253,
                "anoMes": "2026-09-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "OVERCOLL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15253,
                "anoMes": "2026-09-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15253,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15253,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15255,
                "anoMes": "2026-09-01T00:00:00",
                "player": "SHALOM",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15255,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15255,
                "anoMes": "2026-08-01T00:00:00",
                "player": "SHALOM",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15255,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15255,
                "anoMes": "2026-07-01T00:00:00",
                "player": "SHALOM",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15255,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15255,
                "anoMes": "2026-06-01T00:00:00",
                "player": "SHALOM",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15255,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15291,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15291,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15291,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15291,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15293,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15293,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15293,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15293,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15293,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15293,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15293,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.02,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15293,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15308,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15308,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15308,
                "anoMes": "2026-07-01T00:00:00",
                "player": "ARGASSUL",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15308,
                "anoMes": "2026-08-01T00:00:00",
                "player": "ARGASSUL",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15308,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15308,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15308,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15308,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15308,
                "anoMes": "2026-09-01T00:00:00",
                "player": "ARGASSUL",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15308,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15308,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15308,
                "anoMes": "2026-06-01T00:00:00",
                "player": "ARGASSUL",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15324,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15324,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15324,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15324,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15324,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15324,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15324,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 6,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15324,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15324,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 6,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15345,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15345,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15345,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.8,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15345,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.8,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15370,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15370,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15370,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.018,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15370,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15370,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15370,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15370,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.003,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15370,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15370,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15370,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.003,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15370,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15370,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.018,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15370,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15370,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15370,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15370,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0144,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15370,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.003,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15370,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.003,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15370,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15370,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15370,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15370,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15370,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15370,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15370,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.03,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15370,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15370,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15370,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15370,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.006,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15370,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.002,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15370,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15370,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15370,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15370,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15370,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15370,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15370,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15370,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.004,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15370,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15370,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.002,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15398,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 1.5,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15398,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15398,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.03,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15398,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 1.5,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15398,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.03,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15398,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15398,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.1,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO PISCINA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15398,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15398,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.03,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15398,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15398,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO RESINADO / PORCELANATO"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15398,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.03,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15398,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 1.5,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15398,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15399,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15399,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15399,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 1,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15399,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 1,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15417,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15417,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 3,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15417,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15417,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.08,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15417,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 20,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15429,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15429,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15429,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 42,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15429,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.4,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15429,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15429,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.1,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15429,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15429,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 42,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15429,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15429,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.1,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15429,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15429,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.4,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15429,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15429,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15429,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.07,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15429,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.1,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15429,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15429,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 42,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15429,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 42,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15429,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15429,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.1,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15429,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15429,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15429,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.07,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15437,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15437,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15437,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15437,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15437,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 14,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15437,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.03,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15437,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15437,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15437,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 14,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15437,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15437,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.03,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15437,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15437,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 14,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15437,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15437,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15437,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15437,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15437,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15449,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15449,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15449,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15449,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15449,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15449,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15449,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15449,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15449,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15449,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15449,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15449,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15449,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15449,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15449,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15449,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15458,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15458,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15458,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.006,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL (1000)"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15458,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15458,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 42,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15458,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15458,
                "anoMes": "2026-09-01T00:00:00",
                "player": "REBOCAL",
                "consumo": 0.8,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15458,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15458,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "OUTROS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15458,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15458,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15458,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15458,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.02,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO RESINADO / PORCELANATO"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15458,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15458,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 42,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15458,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "OUTROS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15458,
                "anoMes": "2026-08-01T00:00:00",
                "player": "REBOCAL",
                "consumo": 0.8,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15458,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15458,
                "anoMes": "2026-06-01T00:00:00",
                "player": "REBOCAL",
                "consumo": 0.8,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15458,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 44,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15458,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15458,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15458,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15458,
                "anoMes": "2026-06-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 6,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15458,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15458,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15458,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 44,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15458,
                "anoMes": "2026-07-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 6,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15458,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15458,
                "anoMes": "2026-07-01T00:00:00",
                "player": "REBOCAL",
                "consumo": 0.8,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15464,
                "anoMes": "2026-06-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 28,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15464,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15464,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15464,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.12,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15464,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.12,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15464,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15464,
                "anoMes": "2026-07-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 28,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15464,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15464,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15464,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15464,
                "anoMes": "2026-09-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 30,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15464,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15464,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15464,
                "anoMes": "2026-08-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 30,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15464,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 8,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15468,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "PORCELANATO INTERNO CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15468,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15468,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 28,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15468,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15468,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15468,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15468,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15468,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 28,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15468,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15468,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15468,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15468,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15468,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15468,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "PORCELANATO INTERNO CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15468,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "PORCELANATO INTERNO CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15468,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 55,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15468,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15468,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15468,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15468,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15468,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15468,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 12,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15468,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15468,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15468,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 4.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15468,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15468,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "PORCELANATO INTERNO CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15468,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15480,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 30,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15480,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 12,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15480,
                "anoMes": "2026-07-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 10,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15480,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 40,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15480,
                "anoMes": "2026-08-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 14,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15480,
                "anoMes": "2026-09-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 14,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15480,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 40,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15498,
                "anoMes": "2026-06-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 32,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15498,
                "anoMes": "2026-06-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "OVERCOLL"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15498,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 32,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15498,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.6,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15498,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15498,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15498,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 5.2,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15498,
                "anoMes": "2026-07-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 40,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15498,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.8,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15498,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 32,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15498,
                "anoMes": "2026-07-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "OVERCOLL"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15498,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15498,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15498,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 5.2,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15498,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 4.8,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15498,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 64,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15498,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15498,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15498,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15498,
                "anoMes": "2026-08-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 40,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15498,
                "anoMes": "2026-08-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 2.8,
                "grupoProduto": "COLANTES",
                "produto": "OVERCOLL"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15498,
                "anoMes": "2026-09-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 40,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15498,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 64,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15498,
                "anoMes": "2026-09-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 2.8,
                "grupoProduto": "COLANTES",
                "produto": "OVERCOLL"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15498,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15498,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15498,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15498,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 4.8,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15500,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15500,
                "anoMes": "2026-08-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 15,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15500,
                "anoMes": "2026-09-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 15,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15500,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15500,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15500,
                "anoMes": "2026-07-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 15,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15500,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15500,
                "anoMes": "2026-06-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 16,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15506,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 14,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15506,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 28,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15506,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 14,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15506,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 14,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15512,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15512,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.018,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15512,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15512,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.0144,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15512,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15512,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15512,
                "anoMes": "2026-08-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 140,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15512,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15512,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15512,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.018,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15512,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15512,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.0144,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15512,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.018,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15512,
                "anoMes": "2026-07-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 110,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15512,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15512,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15512,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.0072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15512,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15512,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15512,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15512,
                "anoMes": "2026-09-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 155,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15512,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15512,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15512,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15512,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.018,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15512,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15512,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.0144,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15512,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.018,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15512,
                "anoMes": "2026-06-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 82,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15512,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15544,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.3,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15544,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15544,
                "anoMes": "2026-06-01T00:00:00",
                "player": "SHALOM",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15544,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15544,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15544,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.3,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15544,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.02,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15544,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15544,
                "anoMes": "2026-07-01T00:00:00",
                "player": "SHALOM",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15544,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 6,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15544,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15544,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.3,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15544,
                "anoMes": "2026-08-01T00:00:00",
                "player": "SHALOM",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15544,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 6,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15544,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.02,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15544,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.02,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15544,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 6,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15544,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.3,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15544,
                "anoMes": "2026-09-01T00:00:00",
                "player": "SHALOM",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15544,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15568,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.008,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15568,
                "anoMes": "2026-09-01T00:00:00",
                "player": "SIKA",
                "consumo": 0.008,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15568,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15568,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15568,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.0036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15568,
                "anoMes": "2026-09-01T00:00:00",
                "player": "SIKA",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15568,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15568,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.0036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15568,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.008,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15568,
                "anoMes": "2026-08-01T00:00:00",
                "player": "SIKA",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15568,
                "anoMes": "2026-08-01T00:00:00",
                "player": "SIKA",
                "consumo": 0.008,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15568,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15568,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15568,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15568,
                "anoMes": "2026-06-01T00:00:00",
                "player": "SIKA",
                "consumo": 0.008,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15568,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15568,
                "anoMes": "2026-06-01T00:00:00",
                "player": "SIKA",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15568,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15568,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.008,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15568,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15568,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.0072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15568,
                "anoMes": "2026-07-01T00:00:00",
                "player": "SIKA",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15568,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.0072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15568,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15568,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15568,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.008,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15568,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15568,
                "anoMes": "2026-07-01T00:00:00",
                "player": "SIKA",
                "consumo": 0.008,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15602,
                "anoMes": "2026-06-01T00:00:00",
                "player": "SIKA",
                "consumo": 0.018,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15602,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15602,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15602,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15602,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.012,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15602,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 96,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15602,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15602,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.002,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15602,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15602,
                "anoMes": "2026-06-01T00:00:00",
                "player": "SIKA",
                "consumo": 0.015,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15602,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15602,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15602,
                "anoMes": "2026-07-01T00:00:00",
                "player": "SIKA",
                "consumo": 0.018,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15602,
                "anoMes": "2026-07-01T00:00:00",
                "player": "SIKA",
                "consumo": 0.015,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15602,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.012,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15602,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15602,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15602,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15602,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15602,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.002,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15602,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 96,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15602,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15602,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.016,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15602,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.002,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15602,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15602,
                "anoMes": "2026-08-01T00:00:00",
                "player": "SIKA",
                "consumo": 0.03,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15602,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15602,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15602,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15602,
                "anoMes": "2026-08-01T00:00:00",
                "player": "SIKA",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15602,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15602,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15602,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.002,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15602,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15602,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.016,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15602,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15602,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15602,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15602,
                "anoMes": "2026-09-01T00:00:00",
                "player": "SIKA",
                "consumo": 0.03,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15602,
                "anoMes": "2026-09-01T00:00:00",
                "player": "SIKA",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15602,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15602,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15615,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15615,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15615,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15615,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15616,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 14,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15616,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 38,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15616,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 14,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15616,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 14,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15629,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 24,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15629,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15629,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15629,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15629,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 42,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15629,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15629,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 28,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15629,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.03,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15629,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15629,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15629,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15629,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 28,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15630,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 14,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15637,
                "anoMes": "2026-07-01T00:00:00",
                "player": "COLOMBOCAL",
                "consumo": 0.8,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15637,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 28,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15637,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.18,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15637,
                "anoMes": "2026-07-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 120,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15637,
                "anoMes": "2026-07-01T00:00:00",
                "player": "COLOMBOCAL",
                "consumo": 1.2,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15637,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15637,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.162,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15637,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.126,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15637,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.14,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15637,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.18,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15637,
                "anoMes": "2026-08-01T00:00:00",
                "player": "COLOMBOCAL",
                "consumo": 1.2,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15637,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.18,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15637,
                "anoMes": "2026-08-01T00:00:00",
                "player": "COLOMBOCAL",
                "consumo": 0.8,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15637,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 40,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15637,
                "anoMes": "2026-08-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 96,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15637,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15637,
                "anoMes": "2026-09-01T00:00:00",
                "player": "COLOMBOCAL",
                "consumo": 0.8,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15637,
                "anoMes": "2026-09-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 96,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15637,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 40,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15637,
                "anoMes": "2026-09-01T00:00:00",
                "player": "COLOMBOCAL",
                "consumo": 1.2,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15637,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.18,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15637,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.18,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15637,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.14,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15637,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15637,
                "anoMes": "2026-06-01T00:00:00",
                "player": "COLOMBOCAL",
                "consumo": 1,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15637,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 48,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15637,
                "anoMes": "2026-06-01T00:00:00",
                "player": "COLOMBOCAL",
                "consumo": 0.9,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15637,
                "anoMes": "2026-06-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 60,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15637,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.144,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15637,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.2,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15637,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.144,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15637,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.144,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15666,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15666,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15666,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15666,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15671,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15671,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15671,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15671,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15671,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15671,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15671,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15671,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15679,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15679,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15679,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15679,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15679,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15679,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15679,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15679,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15679,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15679,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15679,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15679,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15688,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0225,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15688,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.009,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO PLASTIFICANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15688,
                "anoMes": "2026-06-01T00:00:00",
                "player": "SIKA",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15688,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15688,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO PLASTIFICANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15688,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.3,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15688,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "PSP INTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15688,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15688,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 28,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15688,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15688,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO PLASTIFICANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15688,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.3,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15688,
                "anoMes": "2026-07-01T00:00:00",
                "player": "SIKA",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15688,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15688,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.009,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO PLASTIFICANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15688,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0225,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15688,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "PSP INTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15688,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15688,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15688,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 14,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15688,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.009,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO PLASTIFICANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15688,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15688,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.3,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15688,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0225,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15688,
                "anoMes": "2026-08-01T00:00:00",
                "player": "SIKA",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15688,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO PLASTIFICANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15688,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "PSP INTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15688,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15688,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 14,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15688,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15688,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.009,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO PLASTIFICANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15688,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO PLASTIFICANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15688,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.01,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO EPÓXI"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15688,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.3,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15688,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0225,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15688,
                "anoMes": "2026-09-01T00:00:00",
                "player": "SIKA",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15688,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15688,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15688,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "PSP INTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15688,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 14,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15688,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15698,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.07,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15698,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15698,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15698,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15698,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15698,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15698,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15698,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15710,
                "anoMes": "2026-09-01T00:00:00",
                "player": "BRENNAND",
                "consumo": 0.5,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15711,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15711,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 1,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15711,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15711,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO PISCINA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15711,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.02,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO RESINADO / PORCELANATO"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15711,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.02,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO ACRÍLICO"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15711,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15711,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15711,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 1,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15711,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15711,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.5,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15711,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15711,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15711,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15711,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.5,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15733,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15733,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15733,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.1,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15733,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.1,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15733,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15733,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15733,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.09,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15733,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15733,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15733,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15733,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15733,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15763,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15763,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15763,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15763,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15774,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 42,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15774,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 42,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15774,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15774,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15780,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.0108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15780,
                "anoMes": "2026-08-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 6,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15780,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.0018,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15780,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 52,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15780,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15780,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.0108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15780,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.0018,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15780,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15780,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 52,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15780,
                "anoMes": "2026-09-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 6,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15780,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15780,
                "anoMes": "2026-07-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 10,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15780,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.0018,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15780,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15780,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.0108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15780,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 10,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15780,
                "anoMes": "2026-06-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 10,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15780,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.0018,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15780,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15780,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.0072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15826,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.22,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15826,
                "anoMes": "2026-06-01T00:00:00",
                "player": "ARGASSUL",
                "consumo": 6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15826,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.18,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15826,
                "anoMes": "2026-07-01T00:00:00",
                "player": "ARGASSUL",
                "consumo": 5.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15826,
                "anoMes": "2026-08-01T00:00:00",
                "player": "ARGASSUL",
                "consumo": 5.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15826,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.19,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15826,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.1,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15826,
                "anoMes": "2026-09-01T00:00:00",
                "player": "ARGASSUL",
                "consumo": 6.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15849,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15849,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.12,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15849,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15849,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.12,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15849,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15849,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.12,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15849,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15849,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.12,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15850,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.002,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15850,
                "anoMes": "2026-06-01T00:00:00",
                "player": "SIKA",
                "consumo": 0,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15850,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.008,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15850,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15850,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15850,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.018,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15850,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15850,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15850,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15850,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15850,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15850,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.018,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15850,
                "anoMes": "2026-07-01T00:00:00",
                "player": "SIKA",
                "consumo": 0,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15850,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15850,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15850,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15850,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.008,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15850,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.002,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15850,
                "anoMes": "2026-08-01T00:00:00",
                "player": "SIKA",
                "consumo": 0,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15850,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15850,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15850,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.018,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15850,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.012,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15850,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15850,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.003,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15850,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 6,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15850,
                "anoMes": "2026-09-01T00:00:00",
                "player": "SIKA",
                "consumo": 0.018,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15850,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15850,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15850,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.018,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15850,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.012,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15850,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15850,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.003,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15850,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15865,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15865,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CIPLAN",
                "consumo": 0,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15865,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15865,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 14,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15865,
                "anoMes": "2026-08-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 0,
                "grupoProduto": "COLANTES",
                "produto": "OVERCOLL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15865,
                "anoMes": "2026-09-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 0,
                "grupoProduto": "COLANTES",
                "produto": "OVERCOLL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15865,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15865,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CIPLAN",
                "consumo": 0,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15865,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15865,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 14,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15865,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15865,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 28,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15865,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15865,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CIPLAN",
                "consumo": 0,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15865,
                "anoMes": "2026-07-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 0,
                "grupoProduto": "COLANTES",
                "produto": "OVERCOLL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15865,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15865,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15865,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CIPLAN",
                "consumo": 0,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15865,
                "anoMes": "2026-06-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 0,
                "grupoProduto": "COLANTES",
                "produto": "OVERCOLL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15865,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 54,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15866,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15866,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15866,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 5.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15866,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.1,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15866,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.09,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15866,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15866,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15866,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15881,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15881,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15881,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 15881,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15918,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15918,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15918,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15918,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15918,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15918,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15918,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15918,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15930,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15930,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15930,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15930,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15930,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15930,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15930,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15930,
                "anoMes": "2026-09-01T00:00:00",
                "player": "ARGASSUL",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15930,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15930,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15930,
                "anoMes": "2026-09-01T00:00:00",
                "player": "ARGASSUL",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15930,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "OUTROS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15930,
                "anoMes": "2026-09-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 10,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15930,
                "anoMes": "2026-09-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 1,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15930,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15930,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15930,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15930,
                "anoMes": "2026-08-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 10,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15931,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15931,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15931,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15931,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15931,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "PSP INTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15931,
                "anoMes": "2026-08-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 20,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15931,
                "anoMes": "2026-09-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 20,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15931,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "PSP INTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15931,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15931,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15931,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15931,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15931,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "PSP INTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15931,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15931,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15931,
                "anoMes": "2026-06-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 20,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15931,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15931,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15931,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15931,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "PSP INTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15931,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15931,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15931,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15931,
                "anoMes": "2026-07-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 20,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15949,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15949,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15949,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15949,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15949,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15949,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15949,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15949,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15949,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15949,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15949,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15967,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 1.2,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15967,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 1,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15967,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 1,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15967,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 1,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15983,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15983,
                "anoMes": "2026-06-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 28,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15983,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15983,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15983,
                "anoMes": "2026-07-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 28,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15983,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15983,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15983,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15983,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15983,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.4,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15983,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15983,
                "anoMes": "2026-09-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 32,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15983,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15983,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15983,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 15983,
                "anoMes": "2026-08-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 38,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15992,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15992,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 3,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15992,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15992,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15994,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 3,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15994,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15994,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15994,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15994,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15994,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15994,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2.5,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15994,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15999,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15999,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15999,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15999,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15999,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15999,
                "anoMes": "2026-06-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 12,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15999,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15999,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15999,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.6,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15999,
                "anoMes": "2026-09-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 18,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15999,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15999,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15999,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15999,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.6,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15999,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15999,
                "anoMes": "2026-08-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 17,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15999,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15999,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15999,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15999,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.6,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 15999,
                "anoMes": "2026-07-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 14,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16014,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16014,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16014,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16014,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16014,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 70,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16014,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16014,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16014,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 70,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16014,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16014,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16014,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16014,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16014,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.1,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16014,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16016,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16016,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16016,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16016,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16016,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16016,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16016,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16016,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16016,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16017,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16017,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16017,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16017,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16022,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16022,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16022,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16022,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16025,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 14,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16025,
                "anoMes": "2026-08-01T00:00:00",
                "player": "LIGA ORIGINAL",
                "consumo": 0.4,
                "grupoProduto": "CALES",
                "produto": "SUBS. CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16025,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16025,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16025,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16025,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16025,
                "anoMes": "2026-09-01T00:00:00",
                "player": "LIGA ORIGINAL",
                "consumo": 0.4,
                "grupoProduto": "CALES",
                "produto": "SUBS. CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16025,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 14,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16025,
                "anoMes": "2026-06-01T00:00:00",
                "player": "LIGA ORIGINAL",
                "consumo": 0.4,
                "grupoProduto": "CALES",
                "produto": "SUBS. CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16025,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16025,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16025,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 14,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16025,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16025,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16025,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 14,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16025,
                "anoMes": "2026-07-01T00:00:00",
                "player": "LIGA ORIGINAL",
                "consumo": 0.4,
                "grupoProduto": "CALES",
                "produto": "SUBS. CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16028,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 14,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16028,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16028,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16028,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16028,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16028,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16028,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16028,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16028,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16028,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16030,
                "anoMes": "2026-06-01T00:00:00",
                "player": "REBOCAL",
                "consumo": 0.24,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16030,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16030,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16030,
                "anoMes": "2026-07-01T00:00:00",
                "player": "REBOCAL",
                "consumo": 0.24,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16030,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16030,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.07,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16030,
                "anoMes": "2026-08-01T00:00:00",
                "player": "REBOCAL",
                "consumo": 0.24,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16030,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.07,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16030,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16030,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16030,
                "anoMes": "2026-09-01T00:00:00",
                "player": "REBOCAL",
                "consumo": 0.32,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16030,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.07,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16033,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16033,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16033,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16033,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16033,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16033,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16033,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16033,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16033,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 36,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16033,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16033,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16033,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16033,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16033,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16033,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16033,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16033,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16033,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 36,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16070,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0648,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16070,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.288,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16070,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0432,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16070,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16070,
                "anoMes": "2026-06-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 214,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16070,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.36,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16070,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.012,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16070,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.07,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16070,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 1.6,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16070,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16070,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.1,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16070,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16070,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.52,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16070,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.016,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16070,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16070,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.54,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16070,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0432,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16070,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16070,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.288,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16070,
                "anoMes": "2026-08-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 200,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16070,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.288,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16070,
                "anoMes": "2026-09-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 200,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16070,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.54,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16070,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0432,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16070,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16070,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16070,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16070,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.016,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16070,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.1,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16070,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.52,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16070,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.288,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16070,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16070,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16070,
                "anoMes": "2026-07-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 266,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16070,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0648,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16070,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.012,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16070,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.36,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16070,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16070,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16070,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 1,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16072,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.002,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16072,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16072,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16072,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16072,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16072,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16072,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16072,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16072,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16072,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.002,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16072,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16072,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16072,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16072,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16072,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16072,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16072,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.002,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16072,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16072,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.002,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16072,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16072,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16072,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16072,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16072,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16079,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16079,
                "anoMes": "2026-08-01T00:00:00",
                "player": "SHALOM",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16079,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16079,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16079,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16079,
                "anoMes": "2026-09-01T00:00:00",
                "player": "SHALOM",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16079,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16079,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16079,
                "anoMes": "2026-07-01T00:00:00",
                "player": "SHALOM",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16079,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16079,
                "anoMes": "2026-06-01T00:00:00",
                "player": "SHALOM",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16079,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16081,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 14,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16081,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16081,
                "anoMes": "2026-06-01T00:00:00",
                "player": "COLOMBOCAL",
                "consumo": 0.24,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16081,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.006,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16081,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16081,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.018,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16081,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 80,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16081,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16081,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16081,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.006,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16081,
                "anoMes": "2026-07-01T00:00:00",
                "player": "COLOMBOCAL",
                "consumo": 0.24,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16081,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.018,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16081,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16081,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 176,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16081,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.02,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16081,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.006,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16081,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16081,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16081,
                "anoMes": "2026-08-01T00:00:00",
                "player": "COLOMBOCAL",
                "consumo": 0.24,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16081,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.02,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16081,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.006,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16081,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16081,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16081,
                "anoMes": "2026-09-01T00:00:00",
                "player": "COLOMBOCAL",
                "consumo": 0.24,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16081,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16081,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 176,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16088,
                "anoMes": "2026-09-01T00:00:00",
                "player": "ARGASSUL",
                "consumo": 0.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16088,
                "anoMes": "2026-08-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 0.03,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16088,
                "anoMes": "2026-08-01T00:00:00",
                "player": "ARGASSUL",
                "consumo": 0.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16088,
                "anoMes": "2026-06-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16088,
                "anoMes": "2026-06-01T00:00:00",
                "player": "ARGASSUL",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16088,
                "anoMes": "2026-07-01T00:00:00",
                "player": "ARGASSUL",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16088,
                "anoMes": "2026-07-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16102,
                "anoMes": "2026-09-01T00:00:00",
                "player": "KERACOLL",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO 2 EM 1"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16102,
                "anoMes": "2026-09-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 6,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16102,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16102,
                "anoMes": "2026-08-01T00:00:00",
                "player": "KERACOLL",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO 2 EM 1"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16102,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16102,
                "anoMes": "2026-08-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 8,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16102,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16102,
                "anoMes": "2026-06-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 8,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16102,
                "anoMes": "2026-06-01T00:00:00",
                "player": "KERACOLL",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO 2 EM 1"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16102,
                "anoMes": "2026-07-01T00:00:00",
                "player": "KERACOLL",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO 2 EM 1"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16102,
                "anoMes": "2026-07-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 8,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16102,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16105,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16105,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16105,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16105,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16119,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16119,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16119,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.4,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16119,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16119,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16119,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.4,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16119,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16119,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16119,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16119,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2.8,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16119,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.4,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16119,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16125,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 50,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16125,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16125,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16125,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16125,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16125,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16125,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16125,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 50,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16125,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16125,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16125,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16125,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 30,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16125,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 36,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16125,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16125,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16125,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16133,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16133,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16133,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16133,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16133,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16133,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16133,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16133,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16139,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.324,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16139,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0144,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16139,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.1,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16139,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 5.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16139,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.0288,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16139,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.126,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16139,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.0054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16139,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16139,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 1.04,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16139,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 78,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16139,
                "anoMes": "2026-09-01T00:00:00",
                "player": "LIGA ORIGINAL",
                "consumo": 2,
                "grupoProduto": "CALES",
                "produto": "SUBS. CAL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16139,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0144,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16139,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.324,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16139,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.0036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16139,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.1,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16139,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16139,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.0288,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16139,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16139,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 66,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16139,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 3.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16139,
                "anoMes": "2026-08-01T00:00:00",
                "player": "LIGA ORIGINAL",
                "consumo": 2,
                "grupoProduto": "CALES",
                "produto": "SUBS. CAL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16139,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 1.04,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16139,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0288,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16139,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.0036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16139,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.468,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16139,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.1,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16139,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16139,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.0288,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16139,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16139,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16139,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 1.04,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16139,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 90,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16139,
                "anoMes": "2026-07-01T00:00:00",
                "player": "LIGA ORIGINAL",
                "consumo": 4,
                "grupoProduto": "CALES",
                "produto": "SUBS. CAL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16139,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.0054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16139,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0216,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16139,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.468,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16139,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16139,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16139,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.0288,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16139,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.1,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16139,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16139,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 114,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16139,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 3,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16139,
                "anoMes": "2026-06-01T00:00:00",
                "player": "LIGA ORIGINAL",
                "consumo": 2.4,
                "grupoProduto": "CALES",
                "produto": "SUBS. CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16148,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16163,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16163,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16163,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16163,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16198,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 32,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16198,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CIPLAN",
                "consumo": 75,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16198,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 40,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16198,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CIPLAN",
                "consumo": 70,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16198,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 38,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16198,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CIPLAN",
                "consumo": 76,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16198,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CIPLAN",
                "consumo": 40,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16198,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 24,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16203,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16203,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16203,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL (1000)"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16203,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16203,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16203,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16203,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16203,
                "anoMes": "2026-07-01T00:00:00",
                "player": "TECNOSOFT",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16203,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16203,
                "anoMes": "2026-07-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 3,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16203,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16203,
                "anoMes": "2026-08-01T00:00:00",
                "player": "TECNOSOFT",
                "consumo": 1.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16203,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 4.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16203,
                "anoMes": "2026-08-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 3,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16203,
                "anoMes": "2026-06-01T00:00:00",
                "player": "TECNOSOFT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16203,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16203,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 4.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16213,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16213,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16213,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16213,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16215,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 40,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16215,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 40,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16218,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16218,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16218,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16218,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16218,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.6,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16218,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16218,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16218,
                "anoMes": "2026-08-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 8,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16218,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16218,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16218,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16218,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.6,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16218,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16218,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16218,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16218,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16218,
                "anoMes": "2026-09-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 8,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16218,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16218,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16218,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16218,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16218,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16218,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16218,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16218,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16218,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16218,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16218,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16218,
                "anoMes": "2026-06-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 8,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16218,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 14,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16218,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16218,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16218,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16218,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16218,
                "anoMes": "2026-07-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 8,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16218,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16218,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 14,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16218,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16218,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16218,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16219,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16219,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16219,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16219,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16219,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16219,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16219,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16219,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16219,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16219,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16219,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16219,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4.5,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16223,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 14,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16223,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16223,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16223,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.52,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16223,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16223,
                "anoMes": "2026-07-01T00:00:00",
                "player": "LIGA ORIGINAL",
                "consumo": 1.2,
                "grupoProduto": "CALES",
                "produto": "SUBS. CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16223,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 14,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16223,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16223,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16223,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16223,
                "anoMes": "2026-08-01T00:00:00",
                "player": "LIGA ORIGINAL",
                "consumo": 1.2,
                "grupoProduto": "CALES",
                "produto": "SUBS. CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16223,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.52,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16223,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16223,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16223,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16223,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16223,
                "anoMes": "2026-09-01T00:00:00",
                "player": "LIGA ORIGINAL",
                "consumo": 1.2,
                "grupoProduto": "CALES",
                "produto": "SUBS. CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16223,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16223,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.52,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16223,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 14,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16223,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 28,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16223,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.52,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16223,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16223,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16223,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16223,
                "anoMes": "2026-06-01T00:00:00",
                "player": "LIGA ORIGINAL",
                "consumo": 1.2,
                "grupoProduto": "CALES",
                "produto": "SUBS. CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16225,
                "anoMes": "2026-06-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 32,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16225,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 3.6,
                "grupoProduto": "COLANTES",
                "produto": "PSP INTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16225,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2.8,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16225,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.2,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16225,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16225,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.08,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16225,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16225,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.08,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16225,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2.8,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16225,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16225,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 3.6,
                "grupoProduto": "COLANTES",
                "produto": "PSP INTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16225,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.2,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16225,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16225,
                "anoMes": "2026-07-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 32,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16225,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16225,
                "anoMes": "2026-09-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 64,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16225,
                "anoMes": "2026-09-01T00:00:00",
                "player": "INKOR",
                "consumo": 0.72,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL (1000)"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16225,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.9,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16225,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16225,
                "anoMes": "2026-09-01T00:00:00",
                "player": "INKOR",
                "consumo": 0.54,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16225,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "PSP INTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16225,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.2,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16225,
                "anoMes": "2026-09-01T00:00:00",
                "player": "INKOR",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16225,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16225,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 5.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16225,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "PSP INTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16225,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16225,
                "anoMes": "2026-08-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 30,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16225,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16225,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.9,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16225,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 3.6,
                "grupoProduto": "COLANTES",
                "produto": "PSP INTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16225,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.2,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16225,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 5.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16234,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16234,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16234,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16234,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CAL CEM",
                "consumo": 0.4,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16234,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 8,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16234,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16234,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16234,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16234,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16234,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CAL CEM",
                "consumo": 0.4,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16234,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16234,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16234,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CAL CEM",
                "consumo": 0.4,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16234,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16234,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16234,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16234,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16234,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16234,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16234,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16234,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL (1000)"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16234,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16234,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CAL CEM",
                "consumo": 0.4,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16234,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16234,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.18,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL (1000)"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-09-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.24,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-09-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 0,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.009,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.144,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-09-01T00:00:00",
                "player": "REBOCAL",
                "consumo": 0.32,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-09-01T00:00:00",
                "player": "REBOCAL",
                "consumo": 0.4,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.52,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.36,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-09-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 5,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 78,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-08-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.18,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL (1000)"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-08-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 0,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.009,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.24,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-08-01T00:00:00",
                "player": "REBOCAL",
                "consumo": 0.32,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.36,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-08-01T00:00:00",
                "player": "REBOCAL",
                "consumo": 0.4,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 78,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.52,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-08-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 5,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 40,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-06-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 25,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-06-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.52,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-06-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 0,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.18,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL (1000)"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.009,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-06-01T00:00:00",
                "player": "REBOCAL",
                "consumo": 0.32,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-06-01T00:00:00",
                "player": "REBOCAL",
                "consumo": 0.4,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.36,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-07-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.009,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.18,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL (1000)"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 40,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-07-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 0,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.36,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-07-01T00:00:00",
                "player": "REBOCAL",
                "consumo": 0.4,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-07-01T00:00:00",
                "player": "REBOCAL",
                "consumo": 0.32,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.52,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-07-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 25,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16244,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16256,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "PSP INTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16256,
                "anoMes": "2026-08-01T00:00:00",
                "player": "INKOR",
                "consumo": 1.8,
                "grupoProduto": "COLANTES",
                "produto": "OVERCOLL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16256,
                "anoMes": "2026-08-01T00:00:00",
                "player": "INKOR",
                "consumo": 0.72,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16256,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16256,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16256,
                "anoMes": "2026-08-01T00:00:00",
                "player": "INKOR",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16256,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "PSP INTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16256,
                "anoMes": "2026-07-01T00:00:00",
                "player": "INKOR",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "OVERCOLL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16256,
                "anoMes": "2026-07-01T00:00:00",
                "player": "INKOR",
                "consumo": 0.72,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16256,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16256,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16256,
                "anoMes": "2026-07-01T00:00:00",
                "player": "INKOR",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16256,
                "anoMes": "2026-09-01T00:00:00",
                "player": "INKOR",
                "consumo": 1.8,
                "grupoProduto": "COLANTES",
                "produto": "OVERCOLL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16256,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "PSP INTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16256,
                "anoMes": "2026-09-01T00:00:00",
                "player": "INKOR",
                "consumo": 0.72,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16256,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16256,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16256,
                "anoMes": "2026-09-01T00:00:00",
                "player": "INKOR",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16256,
                "anoMes": "2026-06-01T00:00:00",
                "player": "INKOR",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "OVERCOLL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16256,
                "anoMes": "2026-06-01T00:00:00",
                "player": "INKOR",
                "consumo": 0.72,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16256,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "PSP INTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16256,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16256,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16256,
                "anoMes": "2026-06-01T00:00:00",
                "player": "INKOR",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16258,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 10,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16258,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16258,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16258,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16258,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16258,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16258,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16258,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16258,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16258,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 10,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16258,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16258,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16258,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16258,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16258,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16258,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16258,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16258,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16258,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16258,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16260,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 9,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16260,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16260,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 8,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16260,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16260,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16260,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16264,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16264,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16264,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16264,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16264,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16264,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16264,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16264,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16268,
                "anoMes": "2026-08-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 0.162,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16268,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2.8,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16268,
                "anoMes": "2026-08-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 0.27,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16268,
                "anoMes": "2026-08-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 3.6,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16268,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16268,
                "anoMes": "2026-08-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 6,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16268,
                "anoMes": "2026-08-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16268,
                "anoMes": "2026-08-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 650,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16268,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CIBRACAL",
                "consumo": 1.04,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16268,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.09,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16268,
                "anoMes": "2026-08-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 3.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16268,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 5.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16268,
                "anoMes": "2026-09-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 650,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16268,
                "anoMes": "2026-09-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 3.6,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16268,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CIBRACAL",
                "consumo": 1.04,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16268,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16268,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 5.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16268,
                "anoMes": "2026-09-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 6,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16268,
                "anoMes": "2026-09-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16268,
                "anoMes": "2026-09-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 0.27,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16268,
                "anoMes": "2026-09-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 3.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16268,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2.8,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16268,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.09,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16268,
                "anoMes": "2026-09-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 0.162,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16268,
                "anoMes": "2026-06-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 0.36,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16268,
                "anoMes": "2026-06-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 3.6,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16268,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2.8,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16268,
                "anoMes": "2026-06-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 0.144,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16268,
                "anoMes": "2026-06-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 6,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16268,
                "anoMes": "2026-06-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 686,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16268,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16268,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16268,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CIBRACAL",
                "consumo": 1.04,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16268,
                "anoMes": "2026-06-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16268,
                "anoMes": "2026-06-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 3.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16268,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16268,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CIBRACAL",
                "consumo": 1.04,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16268,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16268,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16268,
                "anoMes": "2026-07-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 686,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16268,
                "anoMes": "2026-07-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 6,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16268,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16268,
                "anoMes": "2026-07-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 3.6,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16268,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2.8,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16268,
                "anoMes": "2026-07-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 3.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16268,
                "anoMes": "2026-07-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16268,
                "anoMes": "2026-07-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 0.144,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16268,
                "anoMes": "2026-07-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 0.36,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16272,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16272,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 28,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16272,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16272,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2.8,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16272,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16272,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.07,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16272,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16272,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.07,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16272,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16272,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16272,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2.8,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16272,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16272,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16272,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16276,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16276,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16276,
                "anoMes": "2026-08-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 12,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16276,
                "anoMes": "2026-09-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 12,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16276,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16276,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16276,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16276,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16276,
                "anoMes": "2026-06-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 12,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16276,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16276,
                "anoMes": "2026-07-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 12,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16276,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16279,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 48,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16279,
                "anoMes": "2026-08-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 16,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16279,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16279,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16279,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16279,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.52,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16279,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16279,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16279,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16279,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16279,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16279,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16279,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL (1000)"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16279,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 48,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16279,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16279,
                "anoMes": "2026-09-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 16,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16279,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.52,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16279,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16279,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16279,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16279,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16279,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 22,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16279,
                "anoMes": "2026-06-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 16,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16279,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16279,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16279,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16279,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16279,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16279,
                "anoMes": "2026-07-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 16,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16279,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16279,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 22,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16279,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16279,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16281,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16281,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 3,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16281,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16281,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16281,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.1,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO RESINADO / PORCELANATO"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16281,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16281,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 3.5,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16281,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 3,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16281,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16282,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16282,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16282,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16282,
                "anoMes": "2026-06-01T00:00:00",
                "player": "TECNOSOFT",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16282,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16282,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.8,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16282,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 3,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16282,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16282,
                "anoMes": "2026-09-01T00:00:00",
                "player": "TECNOSOFT",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16282,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16282,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16282,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16282,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16282,
                "anoMes": "2026-08-01T00:00:00",
                "player": "TECNOSOFT",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16282,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16282,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 3,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16282,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16282,
                "anoMes": "2026-07-01T00:00:00",
                "player": "TECNOSOFT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16285,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.0252,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16285,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16285,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.18,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16285,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.005,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16285,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.0288,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16285,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 3,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16285,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.004,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16285,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16285,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16285,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16285,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.0252,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16285,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 5,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16285,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.18,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16285,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.005,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16285,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.0288,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16285,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.004,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16285,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16285,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16285,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.0288,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16285,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.006,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16285,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.006,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16285,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16285,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16285,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16285,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.18,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16285,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16285,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16285,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.18,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16285,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16285,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16285,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16285,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.006,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16285,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16285,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16285,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.006,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16285,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.0288,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16286,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 3,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16286,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16286,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2.5,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16286,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16286,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16286,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16286,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16286,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16289,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.018,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16289,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16289,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16289,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16289,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16289,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16289,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 70,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16289,
                "anoMes": "2026-07-01T00:00:00",
                "player": "COLOMBOCAL",
                "consumo": 2,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16289,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.24,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16289,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16289,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 48,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16289,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 4.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16289,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16289,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16289,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.018,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16289,
                "anoMes": "2026-08-01T00:00:00",
                "player": "COLOMBOCAL",
                "consumo": 2,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16289,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.018,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16289,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.24,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16289,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16289,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16289,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16289,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.018,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16289,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.018,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16289,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16289,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.24,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16289,
                "anoMes": "2026-09-01T00:00:00",
                "player": "COLOMBOCAL",
                "consumo": 2,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16289,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16289,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 4.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16289,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 48,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16289,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.018,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16289,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16289,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16289,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16289,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16289,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16289,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 70,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16289,
                "anoMes": "2026-06-01T00:00:00",
                "player": "COLOMBOCAL",
                "consumo": 2,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16289,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.24,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16290,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16290,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16290,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16290,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 6,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16290,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16290,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16290,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16290,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16290,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 6,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16290,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.1,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16290,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 3.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16290,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16295,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16295,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.3,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16295,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16295,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16295,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16295,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.3,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16295,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.03,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16295,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16295,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.3,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16295,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.03,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16295,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.02,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16295,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.6,
                "grupoProduto": "COLANTES",
                "produto": "PSP INTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16295,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16295,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16295,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16295,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.3,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16295,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.02,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16295,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16297,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16297,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 6,
                "grupoProduto": "COLANTES",
                "produto": "PORCELANATO INTERNO CINZA"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16297,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.26,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16297,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 252,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16297,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 4.8,
                "grupoProduto": "COLANTES",
                "produto": "PORCELANATO INTERNO CINZA"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16297,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 266,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16297,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16297,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.16,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16297,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.16,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16297,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16297,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 266,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16297,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 4.8,
                "grupoProduto": "COLANTES",
                "produto": "PORCELANATO INTERNO CINZA"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16297,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 6,
                "grupoProduto": "COLANTES",
                "produto": "PORCELANATO INTERNO CINZA"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16297,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 350,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16297,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16297,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.26,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16308,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 1.2,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16308,
                "anoMes": "2026-08-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 146,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16308,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16308,
                "anoMes": "2026-08-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "OVERCOLL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16308,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.24,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16308,
                "anoMes": "2026-08-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16308,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.004,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO PLASTIFICANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16308,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16308,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16308,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.12,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16308,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16308,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 1.2,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16308,
                "anoMes": "2026-09-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 146,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16308,
                "anoMes": "2026-09-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "OVERCOLL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16308,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.24,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16308,
                "anoMes": "2026-09-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16308,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.004,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO PLASTIFICANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16308,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16308,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16308,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16308,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.12,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16308,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16308,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 1.2,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16308,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.24,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16308,
                "anoMes": "2026-06-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16308,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.004,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO PLASTIFICANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16308,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.12,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16308,
                "anoMes": "2026-06-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 160,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16308,
                "anoMes": "2026-06-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "OVERCOLL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16308,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16308,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16308,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16308,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16308,
                "anoMes": "2026-07-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "OVERCOLL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16308,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16308,
                "anoMes": "2026-07-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16308,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.004,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO PLASTIFICANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16308,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16308,
                "anoMes": "2026-07-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 160,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16308,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.12,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16308,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 1.2,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16308,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.24,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16312,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16312,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16312,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16312,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16316,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16316,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CAL CEM",
                "consumo": 0.8,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16316,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16316,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CAL CEM",
                "consumo": 0.8,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16316,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16316,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CAL CEM",
                "consumo": 0.8,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16316,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16316,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CAL CEM",
                "consumo": 1.2,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16318,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16318,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16318,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16318,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.07,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16318,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16318,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.0144,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16318,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL (1000)"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16318,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.056,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16318,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.3,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16318,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.52,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16318,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS (7000)"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16318,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16318,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 80,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16318,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16318,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16318,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16318,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16318,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.07,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16318,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16318,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.0144,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16318,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.056,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16318,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16318,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.3,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16318,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16318,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 30,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16318,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.52,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16318,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.056,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16318,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16318,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.162,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16318,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16318,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.0144,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16318,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16318,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.07,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16318,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 100,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16318,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.52,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16318,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.3,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16318,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16318,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.07,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16318,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.0144,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16318,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16318,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.056,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16318,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.52,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16318,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.3,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16318,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.162,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16318,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16318,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 100,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16318,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16318,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16319,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16319,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16319,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16319,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16323,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16323,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.07,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16323,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16323,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16323,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16323,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16323,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16323,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16324,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16324,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 8,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16324,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16324,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16324,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16324,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16324,
                "anoMes": "2026-06-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 32,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16324,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16324,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16324,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16324,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16324,
                "anoMes": "2026-07-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 32,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16324,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16324,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16324,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 8,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16324,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16324,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL (1000)"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16324,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS (7000)"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16324,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.02,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16324,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16324,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16324,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16324,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 16,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16324,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16324,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16324,
                "anoMes": "2026-09-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 40,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16324,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16324,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16324,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16324,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16324,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16324,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16324,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16324,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16324,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16324,
                "anoMes": "2026-08-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 40,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16324,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 16,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16325,
                "anoMes": "2026-09-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 15,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16325,
                "anoMes": "2026-08-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 15,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16325,
                "anoMes": "2026-07-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 14,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16325,
                "anoMes": "2026-06-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 14,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16327,
                "anoMes": "2026-06-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16327,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16327,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16327,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "PISO SOBRE PISO"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16327,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16327,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16327,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "PISO SOBRE PISO"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16327,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16327,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16327,
                "anoMes": "2026-07-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16327,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16327,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16327,
                "anoMes": "2026-08-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16327,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "PISO SOBRE PISO"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16327,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16327,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16327,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "PISO SOBRE PISO"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16327,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16327,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16330,
                "anoMes": "2026-09-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 32,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16330,
                "anoMes": "2026-08-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 32,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16330,
                "anoMes": "2026-07-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 28,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16330,
                "anoMes": "2026-06-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 38,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16336,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 80,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16336,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16336,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.009,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16336,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16336,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.07,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16336,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16336,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 40,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16336,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16336,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16336,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.009,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16336,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.07,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16336,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16336,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.009,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16336,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.07,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16336,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 70,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16336,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16336,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16336,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16336,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16336,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16336,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16336,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.009,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16336,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 70,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16336,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.07,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16340,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16340,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16340,
                "anoMes": "2026-06-01T00:00:00",
                "player": "COLOMBOCAL",
                "consumo": 0.8,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16340,
                "anoMes": "2026-07-01T00:00:00",
                "player": "COLOMBOCAL",
                "consumo": 0.8,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16340,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16340,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16340,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16340,
                "anoMes": "2026-08-01T00:00:00",
                "player": "COLOMBOCAL",
                "consumo": 0.6,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16340,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16340,
                "anoMes": "2026-09-01T00:00:00",
                "player": "COLOMBOCAL",
                "consumo": 0.6,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16340,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16340,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16340,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16340,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16340,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16349,
                "anoMes": "2026-09-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 20,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16349,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16349,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16349,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16349,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16349,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16349,
                "anoMes": "2026-08-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 20,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16349,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16349,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16349,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16349,
                "anoMes": "2026-07-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 16,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16349,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16349,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16349,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16349,
                "anoMes": "2026-06-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 14,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16349,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16360,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16360,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.02,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16360,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16360,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16360,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 12,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16360,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16360,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.02,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16360,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16360,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16360,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 12,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16360,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16360,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16360,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16360,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16360,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16360,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16360,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16360,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16360,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 470,
                "clienteId": 16360,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16387,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 14,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16387,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16387,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.36,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS (7000)"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16387,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16387,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16387,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.1,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16387,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.1,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16387,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.36,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS (7000)"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16387,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16387,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16387,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 14,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16387,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16387,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16387,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16387,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16387,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.36,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS (7000)"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16387,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16387,
                "anoMes": "2026-08-01T00:00:00",
                "player": "LIZ",
                "consumo": 40,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16387,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16387,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16387,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16387,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.144,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16387,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.36,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS (7000)"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16387,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16387,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16387,
                "anoMes": "2026-09-01T00:00:00",
                "player": "LIZ",
                "consumo": 60,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16391,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16391,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.079,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16391,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16391,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS (7000)"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16391,
                "anoMes": "2026-09-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 40,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16391,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16391,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16391,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS (7000)"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16391,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16391,
                "anoMes": "2026-08-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 40,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16391,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16391,
                "anoMes": "2026-06-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 38,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16391,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS (7000)"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16391,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16391,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 3.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16391,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS (7000)"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16391,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16391,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16391,
                "anoMes": "2026-07-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 38,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 16391,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 3.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16403,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0648,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16403,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.0216,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16403,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.004,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16403,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16403,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.18,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16403,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.252,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16403,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16403,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16403,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 6.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16403,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.624,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16403,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 380,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16403,
                "anoMes": "2026-07-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 32,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16403,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 3.12,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16403,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 416,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16403,
                "anoMes": "2026-08-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 80,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16403,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.0216,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16403,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 9.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16403,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 3.12,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16403,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16403,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.004,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16403,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.288,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16403,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16403,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.16,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16403,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 1.56,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16403,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16403,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.0216,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16403,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.288,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16403,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.16,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16403,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16403,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 1.56,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16403,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16403,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 3.12,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16403,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 9.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16403,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.004,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16403,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16403,
                "anoMes": "2026-09-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 80,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16403,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 416,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16403,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0648,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16403,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.0216,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16403,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.004,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16403,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16403,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.18,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16403,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.252,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16403,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 7.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16403,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16403,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 320,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16403,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16403,
                "anoMes": "2026-06-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 160,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16403,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.624,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 16403,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 3.12,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17394,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17394,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 14,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17394,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.1,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17394,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17394,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.1,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17394,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 14,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17394,
                "anoMes": "2026-09-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "OVERCOLL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17394,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.09,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17394,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.1,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17394,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17394,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17394,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 28,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17394,
                "anoMes": "2026-08-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "OVERCOLL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17394,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17394,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.1,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17394,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 14,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 17430,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "OBRAS ESPECIAIS - INDUSTRIAL"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 17430,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "OBRAS ESPECIAIS - INDUSTRIAL"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 17430,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "OBRAS ESPECIAIS - INDUSTRIAL"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 17430,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "OBRAS ESPECIAIS - INDUSTRIAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17530,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "COLAFIX"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17530,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.2,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17530,
                "anoMes": "2026-06-01T00:00:00",
                "player": "INKOR",
                "consumo": 8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17530,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 5.2,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17530,
                "anoMes": "2026-06-01T00:00:00",
                "player": "REBOCAL",
                "consumo": 0.36,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17530,
                "anoMes": "2026-06-01T00:00:00",
                "player": "INKOR",
                "consumo": 8,
                "grupoProduto": "COLANTES",
                "produto": "OUTROS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17530,
                "anoMes": "2026-06-01T00:00:00",
                "player": "REBOCAL",
                "consumo": 1.2,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17530,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 4.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17530,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 4.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17530,
                "anoMes": "2026-07-01T00:00:00",
                "player": "INKOR",
                "consumo": 8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17530,
                "anoMes": "2026-07-01T00:00:00",
                "player": "INKOR",
                "consumo": 8,
                "grupoProduto": "COLANTES",
                "produto": "OUTROS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17530,
                "anoMes": "2026-07-01T00:00:00",
                "player": "REBOCAL",
                "consumo": 1.2,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17530,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "COLAFIX"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17530,
                "anoMes": "2026-07-01T00:00:00",
                "player": "REBOCAL",
                "consumo": 0.36,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17530,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.2,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17530,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 5.2,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17530,
                "anoMes": "2026-09-01T00:00:00",
                "player": "REBOCAL",
                "consumo": 0.36,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17530,
                "anoMes": "2026-09-01T00:00:00",
                "player": "INKOR",
                "consumo": 9.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17530,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.22,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17530,
                "anoMes": "2026-09-01T00:00:00",
                "player": "REBOCAL",
                "consumo": 1.2,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17530,
                "anoMes": "2026-09-01T00:00:00",
                "player": "INKOR",
                "consumo": 92,
                "grupoProduto": "COLANTES",
                "produto": "OUTROS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17530,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 4.8,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17530,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "COLAFIX"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17530,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17530,
                "anoMes": "2026-08-01T00:00:00",
                "player": "REBOCAL",
                "consumo": 0.36,
                "grupoProduto": "CALES",
                "produto": "CAL PINTURA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17530,
                "anoMes": "2026-08-01T00:00:00",
                "player": "INKOR",
                "consumo": 89.2,
                "grupoProduto": "COLANTES",
                "produto": "OUTROS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17530,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.22,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17530,
                "anoMes": "2026-08-01T00:00:00",
                "player": "REBOCAL",
                "consumo": 1.2,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17530,
                "anoMes": "2026-08-01T00:00:00",
                "player": "INKOR",
                "consumo": 9.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17530,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "COLAFIX"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17530,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 4.8,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17530,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17646,
                "anoMes": "2026-08-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 150,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17646,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "PSP INTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17646,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17646,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 4.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17646,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.1,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17646,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17646,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.1,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17646,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17646,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "PSP INTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17646,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17646,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 4.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17646,
                "anoMes": "2026-09-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 150,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17646,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "PSP INTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17646,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17646,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.16,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17646,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 4.8,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17646,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 4.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17646,
                "anoMes": "2026-07-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 190,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17646,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "PSP INTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17646,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.16,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17646,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 5.6,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17646,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17646,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 4.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17646,
                "anoMes": "2026-06-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 152.5,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17653,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17653,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17653,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17653,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17653,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17653,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17653,
                "anoMes": "2026-08-01T00:00:00",
                "player": "LIZ",
                "consumo": 38,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17653,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17653,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17653,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17704,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 9,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17704,
                "anoMes": "2026-08-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 156,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17704,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17704,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 12,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17704,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17704,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17704,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.07,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17704,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.07,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17704,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17704,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17704,
                "anoMes": "2026-09-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 156,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17704,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17704,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 12,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17704,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 9,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17704,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17704,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17704,
                "anoMes": "2026-07-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 160,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17704,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17704,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17704,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 10,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17704,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 10,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17704,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.1,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17704,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17704,
                "anoMes": "2026-06-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 243,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17704,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17704,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17704,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 13,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 17704,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 13,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.0144,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.18,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0432,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.02,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.002,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-06-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.02,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "CP IV"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 14,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.18,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0432,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.0144,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-07-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.002,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.02,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.02,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "CP IV"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0432,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.002,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.015,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.0144,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.02,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.18,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-08-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 0.09,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 14,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "CP IV"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.18,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-09-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 0.09,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.02,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "CP IV"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.015,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.0144,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VIAPOL",
                "consumo": 0.002,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0432,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 20743,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 14,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 28606,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 28606,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 26,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 28606,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 26,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 28606,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 28606,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 28606,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 56,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 28606,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 28606,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 56,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-06-01T00:00:00",
                "player": "AXTON",
                "consumo": 0.0144,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-06-01T00:00:00",
                "player": "AXTON",
                "consumo": 0.288,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-06-01T00:00:00",
                "player": "AXTON",
                "consumo": 0.104,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-06-01T00:00:00",
                "player": "AXTON",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-06-01T00:00:00",
                "player": "AXTON",
                "consumo": 0.216,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-06-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 0.3,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.09,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-06-01T00:00:00",
                "player": "AXTON",
                "consumo": 0.008,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-06-01T00:00:00",
                "player": "AXTON",
                "consumo": 2.8,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-06-01T00:00:00",
                "player": "AXTON",
                "consumo": 2.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 4.8,
                "grupoProduto": "COLANTES",
                "produto": "PORCELANATO INTERNO CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 42,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-06-01T00:00:00",
                "player": "AXTON",
                "consumo": 6,
                "grupoProduto": "COLANTES",
                "produto": "AC III"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-06-01T00:00:00",
                "player": "AXTON",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-06-01T00:00:00",
                "player": "AXTON",
                "consumo": 0.06,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "COLANTES",
                "produto": "AC III"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.0144,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-06-01T00:00:00",
                "player": "AXTON",
                "consumo": 1.08,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-06-01T00:00:00",
                "player": "AXTON",
                "consumo": 0.756,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.08,
                "grupoProduto": "COLANTES",
                "produto": "AC III CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-08-01T00:00:00",
                "player": "AXTON",
                "consumo": 0.104,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-08-01T00:00:00",
                "player": "AXTON",
                "consumo": 0.048,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-08-01T00:00:00",
                "player": "AXTON",
                "consumo": 0.06,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.0144,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.09,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-08-01T00:00:00",
                "player": "AXTON",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-08-01T00:00:00",
                "player": "AXTON",
                "consumo": 0.288,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-08-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 0.3,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-08-01T00:00:00",
                "player": "AXTON",
                "consumo": 0.216,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-08-01T00:00:00",
                "player": "AXTON",
                "consumo": 0.0144,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-08-01T00:00:00",
                "player": "AXTON",
                "consumo": 0.756,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-08-01T00:00:00",
                "player": "AXTON",
                "consumo": 0.008,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 4.8,
                "grupoProduto": "COLANTES",
                "produto": "PORCELANATO INTERNO CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-08-01T00:00:00",
                "player": "AXTON",
                "consumo": 8,
                "grupoProduto": "COLANTES",
                "produto": "AC III"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "COLANTES",
                "produto": "AC III"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 40,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-08-01T00:00:00",
                "player": "AXTON",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-08-01T00:00:00",
                "player": "AXTON",
                "consumo": 1.08,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-08-01T00:00:00",
                "player": "AXTON",
                "consumo": 2.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-09-01T00:00:00",
                "player": "AXTON",
                "consumo": 0.288,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 40,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-09-01T00:00:00",
                "player": "AXTON",
                "consumo": 0.008,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-09-01T00:00:00",
                "player": "AXTON",
                "consumo": 0.216,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-09-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 0.3,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-09-01T00:00:00",
                "player": "AXTON",
                "consumo": 0.0144,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "COLANTES",
                "produto": "AC III"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.0144,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-09-01T00:00:00",
                "player": "AXTON",
                "consumo": 1.08,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-09-01T00:00:00",
                "player": "AXTON",
                "consumo": 0.756,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-09-01T00:00:00",
                "player": "AXTON",
                "consumo": 2.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-09-01T00:00:00",
                "player": "AXTON",
                "consumo": 0.06,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-09-01T00:00:00",
                "player": "AXTON",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-09-01T00:00:00",
                "player": "AXTON",
                "consumo": 8,
                "grupoProduto": "COLANTES",
                "produto": "AC III"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 4.8,
                "grupoProduto": "COLANTES",
                "produto": "PORCELANATO INTERNO CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-09-01T00:00:00",
                "player": "AXTON",
                "consumo": 0.104,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.09,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-09-01T00:00:00",
                "player": "AXTON",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-09-01T00:00:00",
                "player": "AXTON",
                "consumo": 0.048,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-07-01T00:00:00",
                "player": "AXTON",
                "consumo": 0.0144,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-07-01T00:00:00",
                "player": "AXTON",
                "consumo": 0.048,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-07-01T00:00:00",
                "player": "AXTON",
                "consumo": 0.288,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-07-01T00:00:00",
                "player": "AXTON",
                "consumo": 0.104,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-07-01T00:00:00",
                "player": "FORTALEZA",
                "consumo": 0.3,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.09,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-07-01T00:00:00",
                "player": "AXTON",
                "consumo": 0.008,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-07-01T00:00:00",
                "player": "AXTON",
                "consumo": 0.216,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-07-01T00:00:00",
                "player": "AXTON",
                "consumo": 2.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 4.8,
                "grupoProduto": "COLANTES",
                "produto": "PORCELANATO INTERNO CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-07-01T00:00:00",
                "player": "AXTON",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-07-01T00:00:00",
                "player": "AXTON",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 40,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-07-01T00:00:00",
                "player": "AXTON",
                "consumo": 0.756,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.0144,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA PRETA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-07-01T00:00:00",
                "player": "AXTON",
                "consumo": 1.08,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "COLANTES",
                "produto": "AC III"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-07-01T00:00:00",
                "player": "AXTON",
                "consumo": 8,
                "grupoProduto": "COLANTES",
                "produto": "AC III"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 57075,
                "anoMes": "2026-07-01T00:00:00",
                "player": "AXTON",
                "consumo": 0.06,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-07-01T00:00:00",
                "player": "FORTCOLA",
                "consumo": 6,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 6,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 1.2,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 36,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.006,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO PLASTIFICANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.828,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.216,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO PLASTIFICANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO PLASTIFICANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.216,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.26,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 5.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.216,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 6,
                "grupoProduto": "COLANTES",
                "produto": "AC III"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.006,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.18,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.16,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 6,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 126,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-08-01T00:00:00",
                "player": "FORTCOLA",
                "consumo": 6,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.006,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO PLASTIFICANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.828,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.216,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO PLASTIFICANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO PLASTIFICANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.216,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 1.2,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.18,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 4.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.2,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 8,
                "grupoProduto": "COLANTES",
                "produto": "AC III"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.006,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.216,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.16,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.006,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO PLASTIFICANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 65,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO PLASTIFICANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 6,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-09-01T00:00:00",
                "player": "FORTCOLA",
                "consumo": 6,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.216,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO PLASTIFICANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO PISCINA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 1.2,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.828,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.02,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO EPÓXI"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.216,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.2,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 4.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.006,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.18,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 8,
                "grupoProduto": "COLANTES",
                "produto": "AC III"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.216,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.16,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 6,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 172,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2.4,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-06-01T00:00:00",
                "player": "FORTCOLA",
                "consumo": 4.8,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.006,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO PLASTIFICANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.828,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.144,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "MANTA LIQUIDA BRANCA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.26,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO PLASTIFICANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.216,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO PLASTIFICANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.216,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.216,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 5.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 5.2,
                "grupoProduto": "COLANTES",
                "produto": "AC III"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.006,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.216,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.16,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116104,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.468,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.012,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.12,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS (7000)"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.4,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.006,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 18,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "PORCELANATO INTERNO CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-06-01T00:00:00",
                "player": "FORTCOLA",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC III"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-06-01T00:00:00",
                "player": "FORTCOLA",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 4.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.012,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-08-01T00:00:00",
                "player": "FORTCOLA",
                "consumo": 1.8,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "PORCELANATO INTERNO CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "AC III"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.12,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.4,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.004,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS (7000)"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-08-01T00:00:00",
                "player": "FORTCOLA",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.27,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS (7000)"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.12,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.27,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-09-01T00:00:00",
                "player": "FORTCOLA",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.004,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.012,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "AC III"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-09-01T00:00:00",
                "player": "FORTCOLA",
                "consumo": 1.8,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.4,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "PORCELANATO INTERNO CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.012,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.216,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.108,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.12,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS (7000)"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.004,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA FLEXIVEL COM FIBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2.8,
                "grupoProduto": "COLANTES",
                "produto": "AC III"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-07-01T00:00:00",
                "player": "FORTCOLA",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 18,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "PORCELANATO INTERNO CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.4,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116105,
                "anoMes": "2026-07-01T00:00:00",
                "player": "FORTCOLA",
                "consumo": 1.8,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116106,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116106,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116106,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.004,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116106,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116106,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116106,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.024,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116106,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116106,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116106,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116106,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116106,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116106,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116106,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.024,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116106,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.004,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116106,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116106,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116106,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.004,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116106,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.024,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116106,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116106,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 8,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116106,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116106,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116106,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116106,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.054,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116106,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116106,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116106,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 8,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116106,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116106,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.004,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116106,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.024,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116107,
                "anoMes": "2026-06-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 32,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116107,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.005,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116107,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 4.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116107,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116107,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116107,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116107,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.032,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116107,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.006,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116107,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.104,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116107,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.12,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116107,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116107,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.12,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116107,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.032,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116107,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.036,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116107,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116107,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.104,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116107,
                "anoMes": "2026-07-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 32,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116107,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.005,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116107,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.006,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116107,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 4.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116107,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.005,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116107,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.04,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116107,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116107,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.12,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116107,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.024,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116107,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116107,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116107,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.005,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116107,
                "anoMes": "2026-09-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 64,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116107,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116107,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.064,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116107,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.005,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116107,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116107,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.1,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116107,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.032,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116107,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116107,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116107,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.006,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116107,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116107,
                "anoMes": "2026-08-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 40,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116108,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116108,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.468,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116108,
                "anoMes": "2026-08-01T00:00:00",
                "player": "COLAFIX",
                "consumo": 0.1,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116108,
                "anoMes": "2026-08-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 110,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116108,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0576,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116108,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.288,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116108,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 5.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116108,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.012,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116108,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.02,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116108,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.468,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116108,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0576,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116108,
                "anoMes": "2026-09-01T00:00:00",
                "player": "COLAFIX",
                "consumo": 0.1,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116108,
                "anoMes": "2026-09-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 118,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116108,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.288,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116108,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116108,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.012,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116108,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.02,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116108,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 5.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116108,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116108,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.468,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116108,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.012,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116108,
                "anoMes": "2026-06-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 120,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116108,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.02,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116108,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0576,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116108,
                "anoMes": "2026-06-01T00:00:00",
                "player": "COLAFIX",
                "consumo": 0.1,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116108,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.324,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116108,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 5.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116108,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.324,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116108,
                "anoMes": "2026-07-01T00:00:00",
                "player": "COLAFIX",
                "consumo": 0.1,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116108,
                "anoMes": "2026-07-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 120,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116108,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.0576,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116108,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.02,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116108,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 5.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116108,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.012,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116108,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.072,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 116108,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.468,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 118111,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.44,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 118111,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.8,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL (1000)"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 118111,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VEDACIT (OTTO)",
                "consumo": 0.54,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 118111,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.6,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 118111,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 20,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 118111,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.72,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO DE ADERENCIA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 118111,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 16,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 118111,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 12,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 118111,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 1.44,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 118111,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 118111,
                "anoMes": "2026-09-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 1340,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 118111,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 12.48,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 118111,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 5.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 118111,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 118111,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 6,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 118111,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.3,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 118111,
                "anoMes": "2026-08-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 1350,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 118111,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 118111,
                "anoMes": "2026-06-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 1200,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 118111,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.2,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 118111,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 5.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 118111,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 5.2,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 118111,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.2,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 118111,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 5.2,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 118111,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 5.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 118111,
                "anoMes": "2026-07-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 1200,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 118111,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 342503,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "AC III"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 342503,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 342503,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.14,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 342503,
                "anoMes": "2026-08-01T00:00:00",
                "player": "TECNOSOFT",
                "consumo": 3.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 342503,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2.8,
                "grupoProduto": "COLANTES",
                "produto": "AC III"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 342503,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2.8,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 342503,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.12,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 342503,
                "anoMes": "2026-09-01T00:00:00",
                "player": "TECNOSOFT",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 342503,
                "anoMes": "2026-06-01T00:00:00",
                "player": "TECNOSOFT",
                "consumo": 5.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 342503,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.15,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 342503,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 3.6,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 342503,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "AC III"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 342503,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.15,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 342503,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 3.2,
                "grupoProduto": "COLANTES",
                "produto": "AC III"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 342503,
                "anoMes": "2026-07-01T00:00:00",
                "player": "TECNOSOFT",
                "consumo": 5.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 342503,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 3.6,
                "grupoProduto": "COLANTES",
                "produto": "PSP CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 342504,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 342504,
                "anoMes": "2026-09-01T00:00:00",
                "player": "SHALOM",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 342504,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 342504,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 342504,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 342504,
                "anoMes": "2026-08-01T00:00:00",
                "player": "SHALOM",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 342504,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 342504,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 342504,
                "anoMes": "2026-06-01T00:00:00",
                "player": "SHALOM",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 342504,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 342504,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 342504,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 342504,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 342504,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 342504,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 342504,
                "anoMes": "2026-07-01T00:00:00",
                "player": "SHALOM",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 347470,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 5.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 347470,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.5,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 347470,
                "anoMes": "2026-08-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 9030,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 347470,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 5.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 347470,
                "anoMes": "2026-09-01T00:00:00",
                "player": "KERACOLL",
                "consumo": 76,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 347470,
                "anoMes": "2026-09-01T00:00:00",
                "player": "KERACOLL",
                "consumo": 1,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 347470,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.5,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 347470,
                "anoMes": "2026-09-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 9010,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 347470,
                "anoMes": "2026-06-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 9030,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 347470,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.5,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 347470,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 5.38,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 347470,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.5,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 347470,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 5.38,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 347470,
                "anoMes": "2026-07-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 9030,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 397927,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 8,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 397927,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 397927,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 397927,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 397927,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 397927,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 1.5,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 397927,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 397927,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 397927,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 397927,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 397927,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 397927,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 464151,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 464151,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.03,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 464151,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 464151,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.02,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 464151,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 14,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 464151,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CAL CEM",
                "consumo": 0.6,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 464151,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 464151,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 464151,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.02,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 464151,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 464151,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CAL CEM",
                "consumo": 0.3,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 464151,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 14,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 464151,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 464151,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.02,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 464151,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 464151,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 14,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 464151,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 464151,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CAL CEM",
                "consumo": 0.4,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 464151,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 464151,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 464151,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 464151,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.03,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 464151,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CAL CEM",
                "consumo": 0.4,
                "grupoProduto": "CALES",
                "produto": "CAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 464151,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 14,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 475769,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 475769,
                "anoMes": "2026-06-01T00:00:00",
                "player": "INKOR",
                "consumo": 6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 475769,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 475769,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 475769,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 475769,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 475769,
                "anoMes": "2026-08-01T00:00:00",
                "player": "INKOR",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 475769,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.02,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 475769,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.02,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 475769,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 475769,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 475769,
                "anoMes": "2026-09-01T00:00:00",
                "player": "INKOR",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 475769,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.05,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 475769,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 475769,
                "anoMes": "2026-07-01T00:00:00",
                "player": "INKOR",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 475769,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 623958,
                "anoMes": "2026-07-01T00:00:00",
                "player": "ARGASSUL",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 623958,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 24,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 623958,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 623958,
                "anoMes": "2026-08-01T00:00:00",
                "player": "ARGASSUL",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 623958,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 24,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 623958,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 623958,
                "anoMes": "2026-09-01T00:00:00",
                "player": "ARGASSUL",
                "consumo": 2.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 623958,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 18,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 623958,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.4,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 623958,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 20,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 623958,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 627141,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 627141,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 627141,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.5,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 627141,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.5,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 644124,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 644124,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 644124,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 644124,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 649981,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 649981,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 28,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 649981,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 649981,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 649981,
                "anoMes": "2026-06-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 14,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 649981,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 649981,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 649981,
                "anoMes": "2026-07-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 14,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 649981,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 28,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 649981,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 649981,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 8,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 649981,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 649981,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 649981,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 649981,
                "anoMes": "2026-08-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 26,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 649981,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 649981,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.08,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 649981,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 649981,
                "anoMes": "2026-09-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 26,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 649981,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 8,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 675761,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 675761,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 675761,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 675761,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1035116,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1045750,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1045750,
                "anoMes": "2026-06-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1045750,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1045750,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1045750,
                "anoMes": "2026-07-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1045750,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1045750,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1045750,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.03,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1045750,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1045750,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1045750,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.03,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1045750,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1053544,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 6,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1053544,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1053544,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 6,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1053544,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1053544,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 4,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1053544,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1053544,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 3,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1053544,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1055623,
                "anoMes": "2026-06-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 0.4,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1055623,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 18,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1055623,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL (1000)"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1055623,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1055623,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1055623,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 18,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1055623,
                "anoMes": "2026-07-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 0.4,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1055623,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL (1000)"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1055623,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1055623,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1055623,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL (1000)"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1055623,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1055623,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 48,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1055623,
                "anoMes": "2026-08-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 0.2,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1055623,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1055623,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ARGAMASSA POLIMERICA RIGIDA/SEMIFLEXIVEL (1000)"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1055623,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1055623,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 48,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1055623,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.06,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1055623,
                "anoMes": "2026-09-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 0.2,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1075683,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1075683,
                "anoMes": "2026-08-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 18,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1075683,
                "anoMes": "2026-09-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 18,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1075683,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1075683,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1075683,
                "anoMes": "2026-07-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 20,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1075683,
                "anoMes": "2026-06-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 16,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1079118,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 8,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1079118,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1079118,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 8,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1079118,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1079118,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 10,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1079118,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1079118,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 10,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1079118,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1093541,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2.5,
                "grupoProduto": "CIMENTOS",
                "produto": "OBRAS ESPECIAIS - INDUSTRIAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1093541,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1093541,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1093541,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2.5,
                "grupoProduto": "CIMENTOS",
                "produto": "OBRAS ESPECIAIS - INDUSTRIAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1093541,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2.5,
                "grupoProduto": "CIMENTOS",
                "produto": "OBRAS ESPECIAIS - INDUSTRIAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1093541,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1093541,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2.5,
                "grupoProduto": "CIMENTOS",
                "produto": "OBRAS ESPECIAIS - INDUSTRIAL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1108723,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 1.5,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1108723,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 1.5,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1108723,
                "anoMes": "2026-08-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 4,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1108723,
                "anoMes": "2026-09-01T00:00:00",
                "player": "INTERCEMENT",
                "consumo": 4,
                "grupoProduto": "CIMENTOS",
                "produto": "CP II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1109588,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1109588,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1109588,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1109588,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1109588,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1109588,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1109588,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "IMPERMEABILIZANTES",
                "produto": "ADITIVO IMPERMEABILIZANTE"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1109588,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 1116248,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 6,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 1116248,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 6,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 1116248,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 1118348,
                "anoMes": "2026-06-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 1118348,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 2,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 1118348,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 8,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 1118348,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 8,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1119021,
                "anoMes": "2026-06-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1119021,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1119021,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.6,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1119021,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.3,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1147717,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.6,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1147717,
                "anoMes": "2026-07-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.1,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1147717,
                "anoMes": "2026-07-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 6,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1147717,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.12,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1147717,
                "anoMes": "2026-08-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.8,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1147717,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1147717,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.12,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1147717,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC II"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1147717,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 2,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1147717,
                "anoMes": "2026-09-01T00:00:00",
                "player": "QUARTZOLIT",
                "consumo": 1.8,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1147717,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 6,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1152205,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 3,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1152205,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 3.5,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1160423,
                "anoMes": "2026-09-01T00:00:00",
                "player": "KERACOLL",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1160423,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1160423,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 1.2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1160423,
                "anoMes": "2026-08-01T00:00:00",
                "player": "KERACOLL",
                "consumo": 0.04,
                "grupoProduto": "REJUNTES",
                "produto": "REJUNTAMENTO FLEXÍVEL"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1160749,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1160749,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1160749,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "PSP EXTERNA CINZA"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1160749,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 2,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 1173988,
                "anoMes": "2026-08-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 484,
                "clienteId": 1173988,
                "anoMes": "2026-09-01T00:00:00",
                "player": "CERAMFIX",
                "consumo": 0.8,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1174170,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 8,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1174170,
                "anoMes": "2026-08-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1174170,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 8,
                "grupoProduto": "CIMENTOS",
                "produto": "TODAS AS OBRAS"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1174170,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              },
              {
                "microrregiaoId": 87,
                "clienteId": 1175950,
                "anoMes": "2026-09-01T00:00:00",
                "player": "VOTORANTIM",
                "consumo": 0.4,
                "grupoProduto": "COLANTES",
                "produto": "AC I"
              }
            ]
          },
          {
            "id": 2,
            "winLosses": [
              {
                "dataReferencia": "2026-09-01T00:00:00",
                "wins": [
                  {
                    "codigoCliente": "1125047",
                    "razaoSocial": "ITALAR MATERIAIS PARA CONSTRUCAO",
                    "clienteId": 16318,
                    "consumo": 2.2507
                  },
                  {
                    "codigoCliente": "1669301",
                    "razaoSocial": "M V MATERIAIS PARA CONSTRUCAO LTDA",
                    "clienteId": 15127,
                    "consumo": 1.068
                  },
                  {
                    "codigoCliente": "1238326",
                    "razaoSocial": "CONQUISTA MATERIAIS PARA CONSTRUCAO",
                    "clienteId": 16148,
                    "consumo": 0.8811
                  },
                  {
                    "codigoCliente": "1406643",
                    "razaoSocial": "JANE DE OLIVEIRA LTDA",
                    "clienteId": 15866,
                    "consumo": 0.7637
                  },
                  {
                    "codigoCliente": "1563084",
                    "razaoSocial": "CASTANHEIRA PRESTADORA DE SERVICOS",
                    "clienteId": 15417,
                    "consumo": 0.7517
                  },
                  {
                    "codigoCliente": "1436576",
                    "razaoSocial": "TAMBAIBA MATERIAIS PARA CONSTRUCAO",
                    "clienteId": 15710,
                    "consumo": 0.6608
                  },
                  {
                    "codigoCliente": "1476567",
                    "razaoSocial": "CONSTRU UTIL MATERIAIS DE CONSTRUCA",
                    "clienteId": 15629,
                    "consumo": 0.6433
                  },
                  {
                    "codigoCliente": "1377304",
                    "razaoSocial": "DOMINGOS E GOMES LTDA",
                    "clienteId": 17394,
                    "consumo": 0.63
                  },
                  {
                    "codigoCliente": "1779252",
                    "razaoSocial": "G & A COMERCIO E SERVICOS LTDA",
                    "clienteId": 14648,
                    "consumo": 0.6243
                  },
                  {
                    "codigoCliente": "1366654",
                    "razaoSocial": "GONCALVES E CASTRO LTDA",
                    "clienteId": 16028,
                    "consumo": 0.6167
                  }
                ],
                "loss": [
                  {
                    "codigoCliente": "1367137",
                    "razaoSocial": "ELOS COMERCIO DE MATERIAIS DE",
                    "clienteId": 8231,
                    "consumo": -15.2174
                  },
                  {
                    "codigoCliente": "1529731",
                    "razaoSocial": "TODIMO MATERIAIS PARA CONSTRUCAO SA",
                    "clienteId": 116104,
                    "consumo": -2.5665
                  },
                  {
                    "codigoCliente": "1540227",
                    "razaoSocial": "3A COMERCIO DE TINTAS E MATERIAIS D",
                    "clienteId": 15464,
                    "consumo": -0.3448
                  },
                  {
                    "codigoCliente": "1700265",
                    "razaoSocial": "DEPOSITO COUTINHO MATERIAIS DE",
                    "clienteId": 15115,
                    "consumo": -0.256
                  },
                  {
                    "codigoCliente": "1064386",
                    "razaoSocial": "CARDOSO & CIA LTDA",
                    "clienteId": 16213,
                    "consumo": -0.2013
                  },
                  {
                    "codigoCliente": "1056748",
                    "razaoSocial": "CHAVES JUNIOR & CIA LTDA",
                    "clienteId": 16330,
                    "consumo": -0.1794
                  },
                  {
                    "codigoCliente": "1060252",
                    "razaoSocial": "CLODOMIRO SANTOS DA SILVA",
                    "clienteId": 16234,
                    "consumo": -0.1686
                  },
                  {
                    "codigoCliente": "1830860",
                    "razaoSocial": "K L J ELETRICA & CONSTRUCOES LTDA",
                    "clienteId": 623958,
                    "consumo": -0.167
                  },
                  {
                    "codigoCliente": "1569140",
                    "razaoSocial": "GILMAR PEREIRA GLAGAU",
                    "clienteId": 15393,
                    "consumo": -0.1667
                  },
                  {
                    "codigoCliente": "1793420",
                    "razaoSocial": "TALITA COSTA DE SOUZA",
                    "clienteId": 14643,
                    "consumo": -0.161
                  }
                ]
              }
            ]
          },
          {
            "id": 3,
            "micros": [
              {
                "id": 23,
                "codigo": "531",
                "nome": "VC-BRASILIA"
              },
              {
                "id": 87,
                "codigo": "504",
                "nome": "VC-CAMPO GRANDE"
              },
              {
                "id": 420,
                "codigo": "50B",
                "nome": "VC-IGUATEMI"
              },
              {
                "id": 470,
                "codigo": "502",
                "nome": "VC-AQUIDAUANA"
              },
              {
                "id": 484,
                "codigo": "501",
                "nome": "VC-BAIXO PANTANAL"
              }
            ]
          },
          {
            "id": 4,
            "createdAt": "2026-09-25T07:41:27.135835"
          }
        ]
      }
    ]
  ],
  "existentes": []
}
]]